<template>
  <div class="container mortgage-calculator" :class="calculatorName">

    <div class="row justify-content-center calculator-header">
      <CalculatorHeader>
        <h2>Bad Credit Mortgage Calculator</h2>
        <h4>Fill out a few details to see if you are eligible for Bad Credit Mortgage</h4>
      </CalculatorHeader>
    </div>
    <div class="row justify-content-center calculator-body">
      <div class="col-md-10 col-xl-8">
        <form class="calculator-container">

          <div class="mt-3" @keyup="resetCalculation" @change="resetCalculation">
            <BooleanChoiceButtons
                fieldText="Get Started"
                buttonTextLeft="I'm buying a home"
                buttonTextRight="I'm remortgaging"
            >
              <template v-slot:left>
                <input type="radio" v-model="startOption" value="Buying">
              </template>
              <template v-slot:right>
                <input type="radio" v-model="startOption" value="Remortgaging">
              </template>
            </BooleanChoiceButtons>

            <transition name="fade-x" mode="out-in">
              <!--BOF buying -->
              <div key="buying" v-if="startOption === 'Buying'">
                <BooleanChoiceButtons
                    fieldText="Do you have a property in mind?"
                    buttonTextLeft="Yes"
                    buttonTextRight="No"
                >
                  <template v-slot:left>
                    <input type="radio" v-model="propertyOption" value="Yes">
                  </template>
                  <template v-slot:right>
                    <input type="radio" v-model="propertyOption" value="No">
                  </template>
                </BooleanChoiceButtons>

                <transition name="fade-x" mode="out-in">
                  <InputElement
                      v-show="startOption === 'Buying' && propertyOption === 'Yes'"
                      fieldText="What is the purchase price?"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="purchasePrice"/>
                  </InputElement>
                </transition>

                <transition name="fade-x" mode="out-in">
                  <InputElement
                      v-show="startOption === 'Buying' && propertyOption === 'Yes' && purchasePrice > 0"
                      fieldText="What mortgage amount are you looking for?"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="mortgageAmount"/>
                  </InputElement>
                </transition>
                <!--EOF buying -->      </div>
              <!--BOF remortgaging -->
              <div key="remortgaging" v-if="startOption === 'Remortgaging'">
                <InputElement
                    fieldText="What is the approximate value of your property?"
                >
                  <InputTypeNumber currencyPlaceholder v-model="propertyValue"/>
                </InputElement>

                <transition name="fade-x" mode="out-in">
                  <InputElement
                      v-show="startOption === 'Remortgaging' && propertyValue > 0"
                      fieldText="What is your approximate current mortgage outstanding?"
                  >
                    <InputTypeNumber currencyPlaceholder v-model="outstandingMortgage"/>
                  </InputElement>
                </transition>
                <!--EOF remortgaging -->  </div>
            </transition>

            <transition name="fade-x" mode="out-in">
              <BooleanChoiceButtons
                  v-if="propertyOption === 'No' || ( purchasePrice > 0 && mortgageAmount > 0 ) || ( propertyValue > 0 && outstandingMortgage > 0 )"
                  fieldText="Number of applicants"
                  buttonTextLeft="1"
                  buttonTextRight="2"
              >
                <template v-slot:left>
                  <input type="radio" v-model="applicantsCount" value="1">
                </template>
                <template v-slot:right>
                  <input type="radio" v-model="applicantsCount" value="2">
                </template>
              </BooleanChoiceButtons>
            </transition>

            <transition name="fade-x" mode="out-in">
              <div v-if="applicantsCount > 0 ">
                <transition name="fade-x" mode="out-in">
                  <div v-if="applicantsCount > 0">
                    <h4 class="calc-fieldset-title">First Applicant Details</h4>
                    <InputElement
                        fieldText="First applicant annual income (including benefits)?"
                    >
                      <InputTypeNumber currencyPlaceholder v-model="annualIncome1"/>
                    </InputElement>

                    <transition name="fade-x" mode="out-in">
                      <BooleanChoiceButtons
                          v-if="annualIncome1 > 0"
                          fieldText="Do you have your credit report?"
                          buttonTextLeft="Yes"
                          buttonTextRight="No"
                      >
                        <template v-slot:left>
                          <input type="radio" v-model="creditReport1" value="Yes">
                        </template>
                        <template v-slot:right>
                          <input type="radio" v-model="creditReport1" value="No">
                        </template>
                      </BooleanChoiceButtons>
                    </transition>

                    <transition name="fade-x" mode="out-in">
                      <div class="row mb-5" v-if="annualIncome1 > 0 && creditReport1 === 'Yes'">
                        <div class="col-md-6 col-lg-4">Do you have your credit report?</div>
                        <div class="col-md-6 col-lg-8 fcs-grid">
                          <MultiplyChoiceButton
                              buttonText="Experian"
                          >
                            <input type="radio" v-model="creditAgency1" value="Experian">
                          </MultiplyChoiceButton>
                          <MultiplyChoiceButton
                              buttonText="CreditKarma"
                          >
                            <input type="radio" v-model="creditAgency1" value="CreditKarma">
                          </MultiplyChoiceButton>
                          <MultiplyChoiceButton
                              buttonText="Equifax"
                          >
                            <input type="radio" v-model="creditAgency1" value="Equifax">
                          </MultiplyChoiceButton>
                          <MultiplyChoiceButton
                              buttonText="TransUnion"
                          >
                            <input type="radio" v-model="creditAgency1" value="TransUnion">
                          </MultiplyChoiceButton>
                          <MultiplyChoiceButton
                              buttonText="Clearscore"
                          >
                            <input type="radio" v-model="creditAgency1" value="Clearscore">
                          </MultiplyChoiceButton>
                          <MultiplyChoiceButton
                              buttonText="Check my file"
                          >
                            <input type="radio" v-model="creditAgency1" value="checkMyFile">
                          </MultiplyChoiceButton>
                        </div>
                      </div>
                    </transition>

                    <transition name="fade-x" mode="out-in">
                      <InputElement
                          v-if="annualIncome1 > 0 && creditReport1 && creditAgency1"
                          fieldText="What is your credit score?"
                      >
                        <InputTypeNumber v-model="creditScore1"/>
                      </InputElement>
                    </transition>

                    <transition name="fade-x" mode="out-in">
                      <div class="row mb-5" v-if="creditScore1 > 0">
                        <div class="col-md-6 col-lg-4">
                          Which credit penalties do you have?
                          Please let us know if you have ever received any of the following credit penalties and if so,
                          how long ago was the penalty? (in years)
                        </div>
                        <div class="col-md-6 col-lg-8 fcs-grid-1-2">
                          <div class="calc-question-wrapper">
                            <div>Have you ever had a default?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions"
                                            v-model="previousDefaultedValue1" v-if="previousDefaulted1 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="previousDefaulted1" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="previousDefaulted1" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                          <div class="calc-question-wrapper">
                            <div>Have you had an IVA?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions" v-model="previousIVAValue1"
                                            v-if="previousIVA1 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="previousIVA1" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="previousIVA1" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                          <div class="calc-question-wrapper">
                            <div>Have you had a CCJ?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions" v-model="previousCCJValue1"
                                            v-if="previousCCJ1 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="previousCCJ1" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="previousCCJ1" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                          <div class="calc-question-wrapper">
                            <div>Have you ever had a DMP?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions" v-model="previousDMPValue1"
                                            v-if="previousDMP1 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="previousDMP1" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="previousDMP1" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                          <div class="calc-question-wrapper">
                            <div>Have you ever filed for Bankruptcy?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions"
                                            v-model="previousBankruptcyValue1" v-if="previousBankruptcy1 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="previousBankruptcy1" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="previousBankruptcy1" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                          <div class="calc-question-wrapper">
                            <div>Have you had missed or late payments?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions" v-model="latePaymentsValue1"
                                            v-if="latePayments1 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="latePayments1" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="latePayments1" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>

                  </div>
                </transition>

                <transition name="fade-x" mode="out-in">
                  <div v-if="applicantsCount === '2'">
                    <h4 class="calc-fieldset-title">Second Applicant Details</h4>
                    <InputElement
                        fieldText="Second applicant annual income (including benefits)?"
                    >
                      <InputTypeNumber currencyPlaceholder v-model="annualIncome2"/>
                    </InputElement>

                    <transition name="fade-x" mode="out-in">
                      <BooleanChoiceButtons
                          v-if="annualIncome2 > 0"
                          fieldText="Do you have your credit report?"
                          buttonTextLeft="Yes"
                          buttonTextRight="No"
                      >
                        <template v-slot:left>
                          <input type="radio" v-model="creditReport2" value="Yes">
                        </template>
                        <template v-slot:right>
                          <input type="radio" v-model="creditReport2" value="No">
                        </template>
                      </BooleanChoiceButtons>
                    </transition>

                    <transition name="fade-x" mode="out-in">
                      <div class="row mb-5" v-if="annualIncome2 && creditReport2 === 'Yes'">
                        <div class="col-md-6 col-lg-4">Do you have your credit report?</div>
                        <div class="col-md-6 col-lg-8 fcs-grid">
                          <MultiplyChoiceButton
                              buttonText="Experian"
                          >
                            <input type="radio" v-model="creditAgency2" value="Experian">
                          </MultiplyChoiceButton>
                          <MultiplyChoiceButton
                              buttonText="CreditKarma"
                          >
                            <input type="radio" v-model="creditAgency2" value="CreditKarma">
                          </MultiplyChoiceButton>
                          <MultiplyChoiceButton
                              buttonText="Equifax"
                          >
                            <input type="radio" v-model="creditAgency2" value="Equifax">
                          </MultiplyChoiceButton>
                          <MultiplyChoiceButton
                              buttonText="TransUnion"
                          >
                            <input type="radio" v-model="creditAgency2" value="TransUnion">
                          </MultiplyChoiceButton>
                          <MultiplyChoiceButton
                              buttonText="Clearscore"
                          >
                            <input type="radio" v-model="creditAgency2" value="Clearscore">
                          </MultiplyChoiceButton>
                          <MultiplyChoiceButton
                              buttonText="Check my file"
                          >
                            <input type="radio" v-model="creditAgency2" value="checkMyFile">
                          </MultiplyChoiceButton>
                        </div>
                      </div>
                    </transition>

                    <transition name="fade-x" mode="out-in">
                      <InputElement
                          v-if="annualIncome2 > 0 && creditReport2 && creditAgency2"
                          fieldText="What is your credit score?"
                      >
                        <InputTypeNumber v-model="creditScore2"/>
                      </InputElement>
                    </transition>

                    <transition name="fade-x" mode="out-in">
                      <div class="row mb-5" v-if="creditScore2 > 0">
                        <div class="col-md-6 col-lg-4">
                          Which credit penalties do you have?
                          Please let us know if you have ever received any of the following credit penalties and if so,
                          how long ago was the penalty? (in years)
                        </div>
                        <div class="col-md-6 col-lg-8 fcs-grid-1-2">
                          <div class="calc-question-wrapper">
                            <div>Have you ever had a default?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions"
                                            v-model="previousDefaultedValue2" v-if="previousDefaulted2 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="previousDefaulted2" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="previousDefaulted2" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                          <div class="calc-question-wrapper">
                            <div>Have you had an IVA?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions" v-model="previousIVAValue2"
                                            v-if="previousIVA2 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="previousIVA2" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="previousIVA2" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                          <div class="calc-question-wrapper">
                            <div>Have you had a CCJ?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions" v-model="previousCCJValue2"
                                            v-if="previousCCJ2 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="previousCCJ2" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="previousCCJ2" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                          <div class="calc-question-wrapper">
                            <div>Have you ever had a DMP?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions" v-model="previousDMPValue2"
                                            v-if="previousDMP2 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="previousDMP2" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="previousDMP2" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                          <div class="calc-question-wrapper">
                            <div>Have you ever filed for Bankruptcy?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions"
                                            v-model="previousBankruptcyValue2" v-if="previousBankruptcy2 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="previousBankruptcy2" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="previousBankruptcy2" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                          <div class="calc-question-wrapper">
                            <div>Have you had missed or late payments?</div>
                            <transition name="fade" mode="out-in">
                              <DropdownMenu class="mt-3" :dropdownOptions="dropdownOptions" v-model="latePaymentsValue2"
                                            v-if="latePayments2 == 'Yes'"/>
                            </transition>
                            <div class="calc-merged-btn">
                              <label class="calc-radio left">
                                <input type="radio" v-model="latePayments2" value="Yes">
                                <span class="checkbox large">Yes</span>
                              </label>
                              <label class="calc-radio right">
                                <input type="radio" v-model="latePayments2" value="No">
                                <span class="checkbox large">No</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition>

                  </div>
                </transition>

                <ReturnedValueBox :innerElement=false text="Your household income: " :value="householdIncome"/>
              </div>
            </transition>

            <transition name="fade-x" mode="out-in">
              <div class="row mt-5" v-if="showCalculateButton">
                <div class="col-md-6 col-lg-4">Why are you using the calculator today</div>
                <div class="col-md-6 col-lg-8 fcs-grid-long">
                  <DropdownMenu :dropdownOptions="dropdownOptionsReason" v-model="calcReason1"></DropdownMenu>
                </div>
              </div>
            </transition>

            <transition name="fade-x" mode="out-in">
              <div class="row mt-5 mb-5" v-if="showCalculateButton">
                <div class="col-md-6 col-lg-4">When will you be ready to move forward?</div>
                <div class="col-md-6 col-lg-8 fcs-grid-long">
                  <DropdownMenu :dropdownOptions="dropdownOptionsMove" v-model="calcReason2"></DropdownMenu>
                </div>
              </div>
            </transition>

            <!-- <transition name="fade-x" mode="out-in">
							<InputElement
								v-if="showListFields"
								fieldText="Name"
							>
								<input class="form-control calc-form-control" type="text" v-model="listName">
							</InputElement>
						</transition>

						<transition name="fade-x" mode="out-in">
							<InputElement
								v-if="showListFields"
								fieldText="Email Address"
							>
								<input class="form-control calc-form-control" type="email" v-model="emailAddress">
							</InputElement>
						</transition>

						<transition name="fade-x" mode="out-in">
							<div class="row align-items-center" v-if="showListFields">
								<div class="col-md-1">
									<input type="checkbox" id="privacy" v-model="consent" >
								</div>
								<div class="col-md-11">
									<label for="privacy">I consent to my personal information being processed in accordance with The Mortgage Centres <a href="/cookies-privacy-statement/" target="_blank">Privacy Policy</a></label>
								</div>
							</div>
						</transition> -->

            <transition name="scale-in" mode="out-in">
              <div
                  v-if="showCalculateButton"
                  class="text-center mt-5 mb-3"
              >
                <div class="btn calc-btn-secondary" @click="calculate">CALCULATE</div>
              </div>
            </transition>
          </div>

          <transition name="fade-y" mode="out-in">
            <div v-if="calcCompleted" ref="resultsContainer">

              <ResultsContainer class="mt-5 mb-5 calc-results-box">
                <div class="calculation">{{ chance }}</div>
                <div class="mb-3 results-title">The maximum amount you would be able to borrow is:</div>
                <span class="fcs-price">£{{ availableMortgage.toFixed(2) }}</span>
              </ResultsContainer>

              <SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody"/>

            </div>
          </transition>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
//TODO add ReturnedValueBox household income as per FirstTimeBuyer.vue line 43
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import CalculatorHeader from '@/components/utilities/calculatorHeader.vue'
import DropdownMenu from '@/components/utilities/dropdownMenu.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import ReturnedValueBox from '@/components/utilities/returnedValueBox.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
    CalculatorHeader,
    DropdownMenu,
    InputElement,
    InputTypeNumber,
    MultiplyChoiceButton,
    ResultsContainer,
    ReturnedValueBox,
    SubmissionForm
  },
  data() {
    return {
      calculatorName: 'bad-credit-calculator',
      startOption: "",

      propertyOption: "",
      purchasePrice: null,
      mortgageAmount: null,

      propertyValue: null,
      outstandingMortgage: null,

      applicantsCount: null,

      annualIncome1: 0,
      creditReport1: "",
      creditAgency1: "",
      creditScore1: null,
      previousDefaulted1: "",
      previousDefaultedValue1: 0,
      previousIVA1: "",
      previousIVAValue1: 0,
      previousCCJ1: "",
      previousCCJValue1: 0,
      previousDMP1: "",
      previousDMPValue1: 0,
      previousBankruptcy1: "",
      previousBankruptcyValue1: 0,
      latePayments1: "",
      latePaymentsValue1: 0,

      annualIncome2: 0,
      creditReport2: "",
      creditAgency2: "",
      creditScore2: null,
      previousDefaulted2: "",
      previousDefaultedValue2: 0,
      previousIVA2: "",
      previousIVAValue2: 0,
      previousCCJ2: "",
      previousCCJValue2: 0,
      previousDMP2: "",
      previousDMPValue2: 0,
      previousBankruptcy2: "",
      previousBankruptcyValue2: 0,
      latePayments2: "",
      latePaymentsValue2: 0,

      multiplier: 4.95,

      calculatorReasonTitle: null,
      calculatorReasonResults: null,

      calcReason1: "",
      calcReason2: "",
      listName: "",
			emailAddress: "",
			consent: false,
      chance: '',
      calcCompleted: false,
      dropdownOptions: [
        {value: 0, text: "How Long Ago?"},
        {value: 60, text: "Less than a year"},
        {value: 50, text: "1 year"},
        {value: 40, text: "2 years"},
        {value: 30, text: "3 years"},
        {value: 20, text: "4 years"},
        {value: 10, text: "5 years"},
        {value: 0, text: "6+ years"}
      ],
      dropdownOptionsReason: [
        {value: "Please select an option", text: "Please select an option"},
        {value: "I'm ready to move forward with a mortgage", text: "I'm ready to move forward with a mortgage"},
        {
          value: "I'm not ready for a mortgage but am curious about what I could borrow",
          text: "I'm not ready for a mortgage but am curious about what I could borrow"
        },
        {
          value: "I'm starting to save for a house and want to know what to aim for",
          text: "I'm starting to save for a house and want to know what to aim for"
        },
        {
          value: "I need to understand a what I can afford before house shopping",
          text: "I need to understand a what I can afford before house shopping"
        },
      ],

      dropdownOptionsMove: [
        {value: "Please select an option", text: "Please select an option"},
        {value: "12+ months", text: "12+ months"},
        {value: "6-12 months", text: "6-12 months"},
        {value: "In the next 3 months", text: "In the next 3 months"},
        {value: "As soon as possible", text: "As soon as possible"},
      ],
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
				submitted: false,
				is_valid: false,
				confirmation_message: ''
			},
      formErrors: [],
      gfid: 2, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
			gfidlist: 7 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      if (this.creditScoreValue < 200) {
        this.chance = 'We need more details to be sure';
      }
      if (this.creditScoreValue >= 200) {
        this.chance = 'It might be tough but we could still help';
      }
      if (this.creditScoreValue >= 300) {
        this.chance = 'We may be able to get you a mortgage';
      }
      if (this.creditScoreValue >= 400) {
        this.chance = 'You\'ve got a good chance';
      }
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults =
          `
            Why are you using the calculator today: ${this.calcReason1}
            When will you be ready to move forward: ${this.calcReason2}
            `;
      this.$nextTick(() => {
        const resultsContainer = this.$refs.resultsContainer;

        if (resultsContainer) {
          // Get the bounding rectangle of the element
          const rect = resultsContainer.getBoundingClientRect();

          // Calculate the target scroll position
          const targetScrollPosition = window.scrollY + rect.top - 200;

          // Scroll to the target position
          window.scrollTo({
            top: targetScrollPosition,
            behavior: 'smooth'
          });
        } else {
          console.error('resultsContainer is undefined');
        }
      });
      var newReasonSubmission = new FormData();
			var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
			newListSubmission.append("input_1", this.listName);
			newListSubmission.append("input_3", this.emailAddress);
			newListSubmission.append("input_4.1", this.consent ? 'Yes' : 'No');

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {

        const response = await axios.post(
            `/wp-json/gf/v2/forms/` + this.gfid + `/submissions`, //Please check the Gravity Form form id (staging and live may vary!)
            submissionReasonData,
            {
              headers: {"Content-Type": "application/x-www-form-urlencoded"}
            }
        );

        const submissionReason = response;
        // console.log(submission)

        if (submissionReason.data.is_valid) {
          this.submissionReason.submitted = true;
          this.submissionReason.is_valid = true;
        }
      } catch (error) {
        // console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
            try {

                const response = await axios.post(
                    `/wp-json/gf/v2/forms/`+ this.gfidlist + `/submissions`, //Please check the Gravity Form form id (staging and live may vary!)
                    submissionListData,
                    {
                        headers: {"Content-Type": "application/x-www-form-urlencoded"}
                    }
                );
                
                const submissionList = response;
                // console.log(submission)

                if ( submissionList.data.is_valid ) {
                    this.submissionList.submitted = true;
                    this.submissionList.is_valid = true;
                }
            } catch(error) {
                // console.log(error)
            }
        },
    valueToZero(value) {
      if (!Number.isInteger(value)) {
        return 0
      }
      return value
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function (_, prep, letter) {
        return (prep && ' ') + letter.toUpperCase();
      });
    },
    resetCalculation() {
      this.calcCompleted = false;
    },
    formatEmptyMessageFields(message) {
      return message ? message : 'N/A'
    }
  },
  computed: {
    /**
     * Show 'Calculate' button
     * @return {Boolean}
     */
    showListFields() {
			let listFields
      if (this.applicantsCount < 1) {
        return listFields = false
      }
      this.applicantsCount == 1
          ? (this.creditReport1 === 'No' || (this.previousDefaulted1 !== "" && this.previousIVA1 !== "" && this.previousCCJ1 !== "" && this.previousDMP1 !== "" && this.previousBankruptcy1 !== "" && this.LatePayments1 !== "")) ? listFields = true : listFields = false
          : (this.creditReport2 === 'No' || (this.previousDefaulted2 !== "" && this.previousIVA2 !== "" && this.previousCCJ2 !== "" && this.previousDMP2 !== "" && this.previousBankruptcy2 !== "" && this.LatePayments2 !== "")) && (this.creditReport1 === 'No' || (this.previousDefaulted1 !== "" && this.previousIVA1 !== "" && this.previousCCJ1 !== "" && this.previousDMP1 !== "" && this.previousBankruptcy1 !== "" && this.LatePayments1 !== "")) ? listFields = true : listFields = false
      return listFields
		},
    showCalculateButton() {
      let calculateButton
      if (this.applicantsCount < 1) {
        return calculateButton = false
      }
      this.applicantsCount == 1
          ? (this.creditReport1 === 'No' || (this.previousDefaulted1 !== "" && this.previousIVA1 !== "" && this.previousCCJ1 !== "" && this.previousDMP1 !== "" && this.previousBankruptcy1 !== "" && this.LatePayments1 !== "")) ? calculateButton = true : calculateButton = false
          : (this.creditReport2 === 'No' || (this.previousDefaulted2 !== "" && this.previousIVA2 !== "" && this.previousCCJ2 !== "" && this.previousDMP2 !== "" && this.previousBankruptcy2 !== "" && this.LatePayments2 !== "")) && (this.creditReport1 === 'No' || (this.previousDefaulted1 !== "" && this.previousIVA1 !== "" && this.previousCCJ1 !== "" && this.previousDMP1 !== "" && this.previousBankruptcy1 !== "" && this.LatePayments1 !== "")) ? calculateButton = true : calculateButton = false
      return calculateButton
    },
    /**
     * Calculate total income (of both applicants if available)
     * @return {Number}
     */
    totalIncome() {
      return this.valueToZero(this.annualIncome1) + this.valueToZero(this.annualIncome2)
    },
    /**
     * Calculate maximum mortgage available
     * @return {Number}
     */
    availableMortgage() {
      return this.totalIncome * this.multiplier
    },
    /**
     * Calculate total penalties of the applicant
     * @return {Number}
     */
    creditPenaltiesApplicant1() {
      return parseInt(this.previousDefaultedValue1) + parseInt(this.previousIVAValue1) + parseInt(this.previousCCJValue1) + parseInt(this.previousDMPValue1) + parseInt(this.previousBankruptcyValue1) + parseInt(this.latePaymentsValue1)
    },
    creditPenaltiesApplicant2() {
      return parseInt(this.previousDefaultedValue2) + parseInt(this.previousIVAValue2) + parseInt(this.previousCCJValue2) + parseInt(this.previousDMPValue2) + parseInt(this.previousBankruptcyValue2) + parseInt(this.latePaymentsValue2)
    },
    /**
     * Calculate total score of the applicant
     * @return {Number}
     */
    totalApplicantScore1() {
      let calculatedCreditScore = this.creditScore1 ? this.creditScore1 : 0
      return calculatedCreditScore - this.creditPenaltiesApplicant1
    },
    totalApplicantScore2() {
      let calculatedCreditScore = this.creditScore2 ? this.creditScore2 : 0
      return calculatedCreditScore - this.creditPenaltiesApplicant2
    },
    /**
     * Find the lowest score if more then one applicant
     * @return {Number}
     */
    creditScoreValue() {
      let calculatedCreditScoreValue
      if (this.applicantsCount < 1) {
        return calculatedCreditScoreValue = 0
      }
      this.applicantsCount == 1
          ? calculatedCreditScoreValue = this.totalApplicantScore1
          : calculatedCreditScoreValue = (this.totalApplicantScore1 >= this.totalApplicantScore2) ? this.totalApplicantScore2 : this.totalApplicantScore1
      return calculatedCreditScoreValue
    },
    /**
     * Calculate the total income for the household
     * @return {Number}
     */
    householdIncome() {
      let annualIncome1 = this.annualIncome1 ? this.annualIncome1 : 0;
      let annualIncome2 = this.annualIncome2 ? this.annualIncome2 : 0;

      return annualIncome1 + annualIncome2;
    },
    collateMessageBody() {
      let calculatorData = {
        calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
        calculatorResults:
            `
					Applicants: ${this.applicantsCount}
					Buying or Remortgaging: ${this.startOption}

					Do you have a property in mind? ${this.propertyOption}
					Purchase price: £${this.formatEmptyMessageFields(this.purchasePrice)}
					Mortgage amount: £${this.formatEmptyMessageFields(this.mortgageAmount)}

					Approximate property value: £${this.formatEmptyMessageFields(this.propertyValue)}
					Approximate outstanding mortgage: £${this.formatEmptyMessageFields(this.outstandingMortgage)}

					Applicant 1 Income: £${this.annualIncome1}
					Applicant 1 Credit Report: ${this.formatEmptyMessageFields(this.creditReport1)}
					Applicant 1 Credit Service: ${this.formatEmptyMessageFields(this.creditAgency1)}
					Applicant 1 Credit Score: ${this.formatEmptyMessageFields(this.creditScore1)}
					Applicant 1 Penalties:
							Have you ever had a default? ${this.formatEmptyMessageFields(this.previousDefaulted1)}
							Result: ${this.previousDefaultedValue1}

							Have you had an IVA? ${this.formatEmptyMessageFields(this.previousIVAValue1)}
							Result: ${this.previousIVAValue1}

							Have you had a CCJ? ${this.formatEmptyMessageFields(this.previousCCJ1)}
							Result: ${this.previousCCJValue1}

							Have you ever had a DMP? ${this.formatEmptyMessageFields(this.previousDMP1)}
							Result: ${this.previousCCJValue1}

							Have you ever filed for Bankruptcy? ${this.formatEmptyMessageFields(this.previousBankruptcy1)}
							Result: ${this.previousBankruptcyValue1}

							Have you had missed or late payments? ${this.formatEmptyMessageFields(this.latePayments1)}
							Result: ${this.latePaymentsValue1}

					Applicant 2 Income: ${this.annualIncome2}
					Applicant 2 Credit Report; ${this.formatEmptyMessageFields(this.creditReport2)}
					Applicant 2 Credit Service: ${this.formatEmptyMessageFields(this.creditAgency2)}
					Applicant 2 Credit Score: ${this.formatEmptyMessageFields(this.creditScore2)}
					Applicant 2 Penalties:
							Have you ever had a default? ${this.formatEmptyMessageFields(this.previousDefaulted2)}
							Result: ${this.previousDefaultedValue2}

							Have you had an IVA? ${this.formatEmptyMessageFields(this.previousIVAValue2)}
							Result: ${this.previousIVAValue2}

							Have you had a CCJ? ${this.formatEmptyMessageFields(this.previousCCJ2)}
							Result: ${this.previousCCJValue2}

							Have you ever had a DMP? ${this.formatEmptyMessageFields(this.previousDMP2)}
							Result: ${this.previousCCJValue2}

							Have you ever filed for Bankruptcy? ${this.formatEmptyMessageFields(this.previousBankruptcy2)}
							Result: ${this.previousBankruptcyValue2}

							Have you had missed or late payments? ${this.formatEmptyMessageFields(this.latePayments2)}
							Result: ${this.latePaymentsValue2}

					Household Income: £${this.householdIncome}
					Available Mortgage: £${this.availableMortgage}

					Likelihood Message: ${this.chance}
					Why are you using the calculator today: ${this.calcReason1}
                    When will you be ready to move forward: ${this.calcReason2}
				`
      }
      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>
